import { createSessionService } from './session-service';

/**
 * One session per app: the urql client, the boot sequence and the visibility
 * watchdog all have to agree on whether the Kratos session is alive, and each
 * separate copy used to mean another `whoami` round-trip and another cache to
 * go stale (PSTUDIO-4022).
 */
if (!import.meta.env.FE_KRATOS_ENDPOINT) {
  // Without it every session read is inconclusive, which the apps surface as
  // "the sign-in service could not be reached" — say why, or that screen sends
  // a developer looking for an outage instead of running `vercel env pull`.
  console.error(
    'FE_KRATOS_ENDPOINT is not set: the app cannot verify the Kratos session.'
  );
}

export const sessionService = createSessionService({
  kratosEndpoint: import.meta.env.FE_KRATOS_ENDPOINT,
});
